export function useFlexiblePrice(ticketType) {
    return Boolean(ticketType.currency_amount_max && ticketType.currency_amount_min);
}
